export enum CardTypes {
    NO_ICON = 'NO_ICON',
    DRAGGABLE = 'DRAGGABLE',
    SELECTABLE = 'SELECTABLE'
}
